import React from 'react';

import TextField from '../TextField';

class NumberField extends React.PureComponent {
  state = {
    value: '',
  };

  setValue = value => this.setState({ value });

  handleChange = (e) => {
    this.setValue(e.target.value.replace(/\D/,''));
  };

  render () {
    return (
      <TextField
        {...this.props}
        onChange={this.handleChange}
        value={this.state.value}
      />
    );
  }
}

export default NumberField;




// WEBPACK FOOTER //
// ./src/components/ui/NumberField/NumberField.js